import { ITheme } from "../../utils/theme";

export const titleStyle = (theme: ITheme) => ({
  color: theme.palette.grey.A200,
  marginBottom: 1,
});

export const containerStyle = (theme: ITheme) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  background: 'white',
});

export const cardHeaderStyle = () => ({
  width: 'calc(100% + 2px)',
  position: 'relative',
  left: '-1px',
  backgroundColor: "primary.main",
  color: "primary.contrastText"
});

export const listContainerStyle = (theme: ITheme) => ({
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  padding: 2,
  '&:last-of-type': {
    borderBottom: 'none'
  }
});

export const listItemStyle = () => ({
  padding: 0,
  textDecoration: "underline"
});

export const listItemButtonStyle = () => ({
  paddingLeft: 0,
  color: 'info.main',
  '&:hover': {
    backgroundColor: 'white',
  }
});

export const iconStyle = (theme: ITheme) => ({
  display: 'inline-block',
  marginRight: 1,
  fill: theme.palette.red[600],
});